import Api from '@/services/Api'

export default {
  namespaced: true,

  state: () => ({
    pointFeatures: null
  }),

  mutations: {
    setPointFeatures(state, features) {
      state.pointFeatures = features;
    },
  },

  actions: {
    async fetchPointFeatures({ commit, state }, { forceReload = false } = {}) {

      if (!forceReload && state.pointFeatures) {
        return state.pointFeatures;
      }
      const res = await Api().get('esri-route-object-layer');

      commit("setPointFeatures", res.data);
      return res.data;
    },
  },

  getters: {
    pointFeatures (state) {
      return state.pointFeatures;
    }
  }
}
